interface CreateSliceKeyArgs {
  sliceId: string
  uuid?: string
}

export function createSliceKey(args: CreateSliceKeyArgs) {
  const { sliceId, uuid = crypto.randomUUID() } = args
  return `${sliceId}$${uuid}`
}
